import React, { useState } from 'react';

import './WidgetMessages.scss';
import { useWidgetMessages } from 'widgets/store/stream/selectors';
import { textUtils } from '@instinet-analytics/core-lib';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { WidgetMessage } from './WidgetMessage';
import { MessageIcon } from '@instinet-analytics/semantic-ui-components';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import globalStyleConstants from 'styles/variables.module.scss';
import widgetStyleConstants from './variables.module.scss';
import useOnclickOutside from 'react-cool-onclickoutside';
import { useWidgetContext } from 'widgets/WidgetContext';

const { pluralise } = textUtils;

export interface WidgetMessagesProps {
    hideSeparator?: boolean;
    messages?: StreamMessage[];
}

export function WidgetMessages(props: WidgetMessagesProps) {
    const { hideSeparator, messages: messagesProps } = props;
    const { height: widgetHeight, width } = useWidgetContext();

    const instanceMessages = useWidgetMessages();
    const messages = messagesProps || instanceMessages;
    const [isOpen, setOpen] = useState(false);

    const ref = useOnclickOutside(() => {
        setOpen(false);
    });

    if (messages.length === 0) {
        return <></>;
    }

    const toggleOpen = () => setOpen(!isOpen);

    return (
        <div className="WidgetMessages" ref={ref}>
            <MessageIcon
                onClick={toggleOpen}
                title={pluralise(messages.length, `${messages.length} alert`)}
            />
            {isOpen && renderMessages(messages)}
            {!hideSeparator && <div className="separator" />}
        </div>
    );

    function renderMessages(messages: StreamMessage[]) {
        const maxHeight = widgetHeight
            ? widgetHeight -
              parseInt(globalStyleConstants.toolbarHeight) -
              parseInt(globalStyleConstants.scrollbarSize) -
              parseInt(widgetStyleConstants.headerHeight)
            : 300;

        const maxWidth = 280;
        const panelWidth = Math.min(maxWidth, width * 0.9);
        const panelStyle =
            width > 0
                ? {
                      width: `${panelWidth}px`,
                      left: `${panelWidth * -1}px`,
                  }
                : {};

        return (
            <div className="messages-panel" style={panelStyle}>
                <div className="header">
                    <Icon name="close" onClick={toggleOpen} />
                </div>
                <div
                    className="messages"
                    style={{ maxHeight: maxHeight + 'px' }}
                >
                    {messages.map((m, i) => (
                        <WidgetMessage streamMessage={m} key={i} />
                    ))}
                </div>
            </div>
        );
    }
}
